module.exports = __webpack_public_path__ + "static/media/fb.a76edc8a.svg";